import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { KomunikatyModulMapowyAdapter } from 'src/app/core/adaptery/komunikaty-adapter';
import { Point } from 'src/app/core/modele/point';
import { WysokoscService } from '../../../serwisy/wysokosc.service';
import { KonwerterGeometriUtils } from '../../../utils/konwerter-geometri-utils';
import { PRZYCISK_IKONA_TYP } from 'src/app/modul-mapowy/commons/komponenty/przycisk-ikona/przycisk-ikona.component';
import { Warstwa } from '../../../modele/warstwa';
import { InformacjeOObiekcie } from '../../../utils/obiekty-mapy-utils';
import { Router } from '@angular/router';
import { TlumaczeniaService } from 'src/app/core/tlumaczenia/serwisy/tlumaczenia.service';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'mm-lokalizacja-opis',
  templateUrl: './lokalizacja-opis.component.html',
  styleUrls: ['./lokalizacja-opis.component.scss']
})
export class LokalizacjaOpisComponent implements OnInit, OnChanges, OnDestroy {
  PRZYCISK_IKONA_TYP = PRZYCISK_IKONA_TYP;
  pozycjaKursoraEPSG2178X = '';
  pozycjaKursoraEPSG2178Y = '';
  pozycjaKursoraEPSG4326X = '';
  pozycjaKursoraEPSG4326Y = '';
  wysokosc = '';

  @Input() pozycjaGeograficzna?: Point;

  @Input() obiekt = false;
  @Input() obiektDoLinku?: InformacjeOObiekcie;
  @Input() warstwa?: Warstwa;
  @Input() pokazWspolrzedne?: boolean;
  @Input() narrow: boolean = false;
  aktualnyJezyk = 'pl';
  subskrypcje$ = new Subscription();
  /**
   * Konstruktor
   * @param wysokoscSerwis
   * @param komunikaty
   */
  constructor(private wysokoscSerwis: WysokoscService,
    private komunikaty: KomunikatyModulMapowyAdapter,
    private tlumaczenia: TlumaczeniaService,
    private router: Router) { }


  /**
   * Cykl życia komponentu - inicjalizacja
   */
  ngOnInit(): void {
    this.subskrypcje$.add(this.tlumaczenia.getZmianaJezykaSubject().subscribe(jezyk => {
      this.aktualnyJezyk = jezyk;
    }));
  }

  /**
   * Cykl życia komponentu zmiana
   * @param changes
   */
  ngOnChanges(changes: SimpleChanges): void {
    if (this.pozycjaGeograficzna) {
      this.ustawInformacjeOPozycji(this.pozycjaGeograficzna);
    }
  }

  ngOnDestroy(): void {
    this.subskrypcje$.unsubscribe();
  }
  /**
   * Funkcja kopiuje do schowka lokalizację w układzie EPSG2178
   */
  udostepnijLokalizacjeEPSG2178(): void {
    navigator.clipboard.writeText(`${this.pozycjaKursoraEPSG2178Y}, ${this.pozycjaKursoraEPSG2178X}`);
    this.komunikaty.pokazPomyslnyKomunikat('codes.modul-mapowy.generyczne.pomyslnie-skopiowano', {
      duration: 5000,
      verticalPosition: 'top'
    });
  }

  /**
   * Funkcja kopiuje do schowka kolalizację w układzie EPSG4326
   */
  udostepnijLokalizacjeEPSG4326(): void {
    navigator.clipboard.writeText(`${this.pozycjaKursoraEPSG4326Y}, ${this.pozycjaKursoraEPSG4326X}`);
    this.komunikaty.pokazPomyslnyKomunikat('codes.modul-mapowy.generyczne.pomyslnie-skopiowano', {
      duration: 5000,
      verticalPosition: 'top'
    });
  }
  udostepnijLinkDoObiektu(): void {
    if (this.obiektDoLinku) {
      let queryParams
        = {
        zoom: 12,
        srodekX: this.obiektDoLinku.typ === '2001' ? this.obiektDoLinku.geometria?.getOrdinates().at(0) : this.obiektDoLinku.geometria?.getMBR().getCenter().getX(),
        srodekY: this.obiektDoLinku.typ === '2001' ? this.obiektDoLinku.geometria?.getOrdinates().at(1) : this.obiektDoLinku.geometria?.getMBR().getCenter().getY(),
        lokalizacjaX: this.obiektDoLinku.typ === '2001' ? this.obiektDoLinku.geometria?.getOrdinates().at(0) : this.obiektDoLinku.geometria?.getMBR().getCenter().getX(),
        lokalizacjaY: this.obiektDoLinku.typ === '2001' ? this.obiektDoLinku.geometria?.getOrdinates().at(1) : this.obiektDoLinku.geometria?.getMBR().getCenter().getY(),
        lang: this.aktualnyJezyk
      }
      const url = `${environment.baseUrl}${window.location.pathname}?srodekX=${queryParams.srodekX}&srodekY=${queryParams.srodekY}&lokalizacjaX=${queryParams.lokalizacjaX}&lokalizacjaY=${queryParams.lokalizacjaY}&zoom=${queryParams.zoom}&lang=${queryParams.lang}`;
      navigator.clipboard.writeText(url);
      this.komunikaty.pokazPomyslnyKomunikat('codes.modul-mapowy.generyczne.pomyslnie-skopiowano', {
        duration: 5000,
        verticalPosition: 'top'
      });
    }
  }
  /**
   * Funkcja aktualizuje informacje o położeniu obiektu/kliknieciu
   * @param pozycjaMyszki
   */
  private ustawInformacjeOPozycji(pozycjaMyszki: Point): void {
    this.pozycjaKursoraEPSG2178X = KonwerterGeometriUtils.formatujDoCalkowitych(pozycjaMyszki.getX());
    this.pozycjaKursoraEPSG2178Y = KonwerterGeometriUtils.formatujDoCalkowitych(pozycjaMyszki.getY());
    const poycjaEPSG4326 = KonwerterGeometriUtils.EPSG2178toEPSG4326(pozycjaMyszki.getX(), pozycjaMyszki.getY());
    this.pozycjaKursoraEPSG4326X = poycjaEPSG4326?.x ? poycjaEPSG4326.x.toFixed(6) : '';
    this.pozycjaKursoraEPSG4326Y = poycjaEPSG4326?.y ? poycjaEPSG4326.y.toFixed(6) : '';
    if (!this.obiekt) {
      const wysokoscNpm = this.wysokoscSerwis.pobierzWysokoscNPM(pozycjaMyszki.getX(), pozycjaMyszki.getY());
      this.wysokosc = wysokoscNpm ? wysokoscNpm.toString() : '--';
    }
  }
}
